export default __webpack_public_path__ + "static/home-benefits-32a6871a0503f1f99592923ac8078359.mp4";